import React from "react";

export default function TextInput(props) {
  return (
    <input
      type="text"
      className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30 focus:outline-indigo-400"
      placeholder={props.placeholder}
      id={props.id}
      name={props.name}
      onChange={props.onChange}
      
    />
  );
}
